angular.module('kareo.product-setup-configuration', [
  'kareo.ui.shared.modules.product-setup', 'kareo.environment'])
  .run(['ProductSetup', 'KareoEnvironment',
    function (ProductSetup, environment) {
      if (!environment.isInPm) {
        ProductSetup.isProductSetupRequired();
      }
    }]);
